module.exports = __webpack_public_path__ + "static/media/longmont_pastor.c4f0ccde.jpg";